var modules_1ba53a2f = {"global-search":"GlobalSearch_module_globalSearch__ab01658a"};
import "../../../assets/esm/components/Table/src/GlobalSearch~waAvYfcL.css";

export { modules_1ba53a2f as default };
//# sourceMappingURL=GlobalSearch.module.less.js.map
